export const DEFAULT_RPC_URL = 'wss://rococo-contracts-rpc.polkadot.io';

export const FIVE_SECONDS = 5000;
export const HALF_A_SECOND = 500;
